import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import {
  PageHeader,
  PageContainer,
  PageFormContainer,
} from "src/components/Page";
import { useUserSessionInit } from "src/hooks";
import { logPageView } from "src/utils";
export type DashboardLayoutPropsWIthChildren = {
  pageTitle: string;
  backHandler?: () => void;
} & PropsWithChildren;

export default ({
  pageTitle,
  backHandler,
  children,
}: DashboardLayoutPropsWIthChildren) => {
  useUserSessionInit();

  useEffect(() => {
    document.title = `${pageTitle} - PorchPass`;
    logPageView();
  }, []);

  return (
    <>
      <PageHeader onBackClick={backHandler} />
      <PageContainer>
        <PageFormContainer>{children}</PageFormContainer>
      </PageContainer>
    </>
  );
};
